import React from "react";
import "./ContactDetails.css";

const ContactDetails = () => {
  return (
    <section id="contactdetails" className="contact-details">
      <h2>Contact Information</h2>
      <p><strong>Email:</strong> suraj@innorock.org</p>
      <p><strong>Phone:</strong> +1 (431) 356-2005</p>
      <p><strong>Office:</strong> 51 Mount Allison Bay, Winnipeg, MB, Canada</p>
    </section>
  );
};

export default ContactDetails;